import { render, staticRenderFns } from "./complex-table.vue?vue&type=template&id=18d997e5&"
import script from "./complex-table.vue?vue&type=script&lang=js&"
export * from "./complex-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports